import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Icon, IconButton } from '@dixa/lib-shared-habla';
import { colors } from '@dixa/lib-shared-tokens';
import classnames from 'classnames';
import * as React from 'react';
import styles from './flowNode.module.scss';
export const flowNodeColor = {
    default: '#8294B0',
    green: colors.green['500'],
    red: colors.red['500'],
    orange: colors.orange['500'],
    purple: colors.purple['500'],
    blue: colors.blue['400'],
};
export class FlowNode extends React.PureComponent {
    constructor() {
        super(...arguments);
        this.stopPropagation = (e) => {
            e.stopPropagation();
        };
    }
    render() {
        const { className, icon, color, label, text, onEdit, style } = this.props;
        const rootClass = classnames({
            [styles.root]: true,
            [styles.rootNoText]: !text,
        }, className);
        const hasAction = !!onEdit;
        return (_jsxs("div", Object.assign({ className: rootClass, style: style }, { children: [_jsxs("div", Object.assign({ className: styles.label }, { children: [_jsx("div", { className: styles.labelColor, style: { backgroundColor: color } }), icon && (_jsx(Icon, { name: icon, className: classnames(styles.labelIcon, 'icon-vertical-fix') })), _jsx("span", Object.assign({ className: styles.labelName }, { children: label })), hasAction && (_jsx("div", Object.assign({ className: styles.labelActions }, { children: _jsx(IconButton, { variant: "tertiary", icon: "pen", className: styles.labelAction, onClick: onEdit, onMouseDown: this.stopPropagation }) })))] })), !!text && _jsx("div", Object.assign({ className: styles.text }, { children: text }))] })));
    }
}
FlowNode.defaultProps = {
    color: flowNodeColor.default,
};
FlowNode.dimensions = {
    h: 64,
    w: 250,
};
